import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloMeta, cleanAloMeta } from '@/models/alo/AloMeta'
import { ApiResultCode } from '@/enum/ApiResultCode'

export default {
  getAllMeta(): AxiosPromise<AlrContainer<Array<AloMeta>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Meta`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloMeta>>
      }]
    })
  },
  getMeta(id:number):AxiosPromise<AlrContainer<AloMeta>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Meta/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMeta>
      }]
    })
  },
  saveMeta(meta:AloMeta):AxiosPromise<AlrContainer<AloMeta>> {
    cleanAloMeta(meta)
    if(meta.id) {
      const oldId = meta.id
      meta.id = meta.newId
      delete meta.newId
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/Meta/${oldId}`, 
        method: 'PUT',
        data: meta,
        transformResponse: [function (data:string) {   
          const  resp = JSON.parse(data) as AlrContainer<AloMeta>     
          if(resp.resultCode == ApiResultCode.Ok){
            //@ts-ignore
            resp.data.newId = oldId
          }  
          return resp
        }]
      })    
    }
    else{
      meta.id = meta.newId
      delete meta.newId
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/Meta`, 
        method: 'POST',
        data: meta,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMeta>
        }]
      })    
    }
  },
  deleteMeta(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Meta/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<number>
      }]
    })
  }
}